<template>
  <el-table
    :data="list"
    border=""
    :row-class-name="tableRowClassName"
    height="300px">
    <!-- <el-table-column
      prop="wareshouseName"
      label="仓库名称">
    </el-table-column> -->
    <el-table-column
      prop="productName"
      label="产品名称">
    </el-table-column>
    <el-table-column
      width="80"
      prop="stockQuantity"
      :formatter="row=> row.stockQuantity + '件'"
      label="库存数">
    </el-table-column>
    <el-table-column
      width="80"
      prop="lowQuota"
      :formatter="row=> row.lowQuota + '件'"
      label="安全库存">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'SafeSkuTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.stockQuantity < row.lowQuota) {
        return 'warning-row'
      }
      return ''
    }
  }
}
</script>

<style lang="stylus">
  .el-table .warning-row {
    background: oldlace !important;
  }
</style>
